import { render, staticRenderFns } from "./nav-section.vue?vue&type=template&id=1336bd21&scoped=true"
import script from "./nav-section.vue?vue&type=script&lang=ts"
export * from "./nav-section.vue?vue&type=script&lang=ts"
import style0 from "./nav-section.vue?vue&type=style&index=0&id=1336bd21&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1336bd21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1336bd21')) {
      api.createRecord('1336bd21', component.options)
    } else {
      api.reload('1336bd21', component.options)
    }
    module.hot.accept("./nav-section.vue?vue&type=template&id=1336bd21&scoped=true", function () {
      api.rerender('1336bd21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/nav-section.vue"
export default component.exports